"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_FLOAT_REGEX = exports.HBMONEY_INPUT_PADDING = exports.ALLOWED_SPECIAL_KEYS_ON_INPUT = void 0;
exports.falseNotZero = falseNotZero;
exports.isNonNumberKey = isNonNumberKey;
exports.isSecondDot = isSecondDot;
function falseNotZero(value) {
  return !value && value !== 0;
}
var IS_FLOAT_REGEX = exports.IS_FLOAT_REGEX = /^\d*(\.\d?\d?)?$/; // matches the following (d for any digit): 'd', 'd.','d.d', 'd.dd'

var ALLOWED_SPECIAL_KEYS_ON_INPUT = exports.ALLOWED_SPECIAL_KEYS_ON_INPUT = ['Delete', 'Backspace', 'ArrowRight', 'Meta', 'Tab', 'ArrowLeft'];
function isNonNumberKey(e, ctrlOn) {
  // allow numbers and clipboard shortcuts
  return !(IS_FLOAT_REGEX.test(e.key) || ctrlOn && ALLOWED_CLIPBOARD_CHARS.includes(e.key));
}
function isSecondDot(e) {
  var _e$currentTarget$valu;
  return e.key === '.' && ((_e$currentTarget$valu = e.currentTarget.value) === null || _e$currentTarget$valu === void 0 ? void 0 : _e$currentTarget$valu.includes('.'));
}
var ALLOWED_CLIPBOARD_CHARS = ['v', 'c', 'a', 'x'];
var HBMONEY_INPUT_PADDING = exports.HBMONEY_INPUT_PADDING = {
  xs: {
    paddingLeft: '12px'
  },
  sm: {
    paddingLeft: '20px'
  },
  md: {
    paddingLeft: '22px'
  },
  lg: {
    paddingLeft: '26px'
  },
  xl: {
    paddingLeft: '32px'
  }
};
//# sourceMappingURL=HBMoneyInput.utils.js.map